<template>
    <div class="apple">
        <div class="pic">
            <img src="../../assets/img/tool－bg2.png" alt="">
        </div>
        <main class="apple-main">
            <img src="../../assets/img/tools－image－5.png" alt="">
            <img src="../../assets/img/tools－image－6.png" alt="">
            <img src="../../assets/img/tools－image－7.png" alt="">
            <img src="../../assets/img/tools－image－8.png" alt="">
        </main>
    </div>
</template>

<script>
    export default {
        name: 'Mapple',
        data() {
            return {

            };
        },
        methods: {

        }
    }
</script>

<style scoped lang='scss'>
    img {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/Mapply.vue